import { Pipe, PipeTransform, inject } from '@angular/core';
import { UseSeparatorService } from 'src/app/shared/components/form-kit/form-field/use-separator.service';

@Pipe({
  name: 'numberSeparator',
  standalone: true,
})
export class NumberSeparatorPipe implements PipeTransform {
  // isUseSeparator: boolean = true;
  useSeparatorService: UseSeparatorService = inject(UseSeparatorService);

  isUseSeparator: boolean = true;
  transform(value: any, args?: any): any {
    // // UseSeparatorService.useSeparator.subscribe((useSeparator) => {
    // //   this.isUseSeparator = useSeparator;
    // // });
    // if (!this.isUseSeparator) return value;
    // if (args) return value;
    // return value?.toLocaleString();
    if (value == 0) return 0;
    if (!value) return '';
    this.isUseSeparator = this.useSeparatorService.useSeparator();
    if (!this.isUseSeparator) return value;

    return value?.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
    });
  }
}
